import {FC, MouseEventHandler} from 'react'

type Props = {
  disabled?: boolean
  loading?: boolean
  icon?: string
  svgIcon?: React.ReactElement
  btnClass?: string
  btnAttr?: object
  text: string
  size?: string
  outline?: boolean
  color: string
  iconColor?: string
  horizontalPadding?: number
  verticalPadding?: number
  click: MouseEventHandler<HTMLButtonElement>
  width?: string
  height?: string
  uppercase?: boolean
  title?: string
  txtClass?: string
  blankHref?: string
  fontColor?: string
}

const Button: FC<Props> = (props) => {
  const {
    disabled,
    loading,
    icon,
    svgIcon,
    btnClass,
    btnAttr,
    text,
    size,
    outline,
    color,
    horizontalPadding,
    verticalPadding,
    iconColor,
    click,
    width,
    height,
    uppercase,
    title,
    txtClass,
    blankHref,
    fontColor,
  } = props

  let adapted = ''
  if (!iconColor?.includes('#')) {
    if (iconColor === 'success') adapted = '#50cd89'
    else if (iconColor === 'primary') adapted = '#6993FF'
    else if (iconColor === 'secondary') adapted = '#3F4254'
    else if (iconColor === 'danger') adapted = '#f1416c'
    else if (iconColor === 'info') adapted = '#8950fc'
  }

  return (
    <button
      {...btnAttr}
      title={title}
      className={
        `btn ${outline ? `btn-outline-${color} border border-${color}` : `btn-${color}`} btn-${
          size === 'small' ? 'sm' : 'lg'
        }
        ${horizontalPadding ? `px-${horizontalPadding}` : ''} ${
          verticalPadding ? `py-${verticalPadding}` : ''
        } 
        ${width && `w-${width}`}  ${height && `h-${height}`} ${uppercase && 'text-uppercase'} ` +
        btnClass
      }
      disabled={disabled}
      onClick={click}
      style={{...(fontColor && {color: fontColor})}}
    >
      {!loading && icon && (
        <i
          style={{
            marginRight: `${text ? '.8em' : ''}`,
            color: iconColor?.includes('#') ? iconColor : adapted,
          }}
          className={icon}
        ></i>
      )}

      {!loading && svgIcon ? <div>{svgIcon}</div> : <></>}

      {!loading &&
        (blankHref ? (
          <a
            style={{color: 'inherit'}}
            className={`indicator-label ${txtClass ? txtClass : ''}`}
            href={blankHref}
            target='_blank'
          >
            {text}
          </a>
        ) : (
          <span className={`indicator-label ${txtClass ? txtClass : ''}`}>{text}</span>
        ))}
      {loading && (
        <span className='indicator-progress' style={{display: 'block'}}>
          <span className='spinner-border spinner-border-sm align-middle'></span>
        </span>
      )}
    </button>
  )
}

export {Button}
